import * as React from 'react'
import css from '@emotion/css'

export enum HoverFeature {
  /* Primary input mechanism system can 
   hover over elements with ease */
  Hover = 'hover',
  /* Primary input mechanism cannot hover 
   at all or cannot conveniently hover 
   (e.g., many mobile devices emulate hovering
   when the user performs an inconvenient long tap), 
   or there is no primary pointing input mechanism */
  None = 'none',
}

export function HoverCapability(props: {
  feature: HoverFeature
  children: React.ReactNode
}) {
  const { feature, children } = props

  const classes =
    feature === HoverFeature.Hover
      ? css`
          @media (hover: none) {
            display: none;
          }
        `
      : css`
          @media (hover: hover) {
            display: none;
          }
        `

  return <div css={classes}>{children}</div>
}
